<template>
  <ConfirmDeleteScheduleModal />
  <div class="modal fade" id="updateScheduleModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 v-if="getCurrentCalendar" class="modal-title fs-5">{{ getCurrentCalendar.status == 'BLOCKED' ? 'Bloqueio' : 'Agendamento' }}</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <div class="modal-body">

                <h1 class="modal-title fs-5">
                  Data: {{ formattedDate }} ({{ weekDay }})
                </h1>

                <!-- {{ getCurrentCalendar.service }} -->
                <a
                  v-if="getCurrentCalendar && getCurrentCalendar.client && getCurrentCalendar.service"
                  :href="`https://wa.me/55${getCurrentCalendar.client.phone}?text=Olá!%20Tudo%20bem?%0AEstou%20passando%20para%20confirmar%20seu%20agendamento%20de%20*${getCurrentCalendar.service.name}*%20%0A*Data:*%20${formattedDate}%20(${weekDay})%0A*Horário:*%20${selectedTime.substring(0,5)}%0A*Valor:*%20${getCurrentCalendar.base_price_formatted}${getCurrentCalendar.company && getCurrentCalendar.company.address ? '%0A*Endereço:*%20' + getCurrentCalendar.company.address : ''}%0A%0APor%20favor,%20responda%20com%20CONFIRMADO%20para%20garantir%20seu%20horário!%0A%0ACaso%20precise%20remarcar,%20é%20só%20me%20avisar!`"
                  target="_blank"
                  class="btn btn-success mt-3 col-12 d-flex justify-content-center align-items-center"
                >
                  Enviar lembrete via WhatsApp
                  <i class="ph ph-whatsapp-logo position-relative ms-5 fs-20"></i>
                </a>

                <div v-if="getCurrentCalendar && getCurrentCalendar.status != 'BLOCKED'">
                  <div class="mt-3 mb-3">
                    <label for="time-service" class="form-label">Categoria:</label>
  
                    <input
                      :value="getCurrentCalendar.category.name"
                      type="text"
                      class="form-control"
                      placeholder="Categoria..."
                      disabled
                    >
                  </div>
  
                  <div class="mt-3 mb-3">
                    <label for="time-service" class="form-label">Serviço:</label>
  
                    <input
                      :value="getCurrentCalendar.service.name"
                      type="text"
                      class="form-control"
                      placeholder="Serviço..."
                      disabled
                    >
                  </div>

                  <div class="mt-3 mb-3">
                    <label for="time-service" class="form-label">Atendente:</label>
  
                    <input
                      :value="getCurrentCalendar.user.name"
                      type="text"
                      class="form-control"
                      placeholder="Atendente..."
                      disabled
                    >
                  </div>

                  <label for="time-service" class="form-label mt-3">Cliente:</label>

                  <div class="col-12 mb-3 d-flex justify-content-between">
                    <div class="col-10 col-sm-11 pe-10">
    
                      <input
                        :value="getCurrentCalendar.client.phone + ' - ' + (getCurrentCalendar.client.name != null ? getCurrentCalendar.client.name : 'Sem nome')"
                        type="text"
                        class="form-control"
                        placeholder="Cliente..."
                        disabled
                      >
                    </div>
                    <div class="col-2 col-sm-1 pe-10">
                      <a
                        v-if="getCurrentCalendar && getCurrentCalendar.client"
                        :href="`https://wa.me/55${getCurrentCalendar.client.phone}`"
                        target="_blank"
                        class="btn btn-success col-12 d-flex justify-content-center align-items-center"
                      >
                        <i class="ph ph-whatsapp-logo position-relative ms-5 fs-20"></i>
                      </a>
                    </div>
                  </div>


                  <div class="mt-3 mb-3">
                    <label for="date-service" class="form-label">Data:</label>
  
                    <input
                      ref="dateServiceInput"
                      id="date-service"
                      type="text"
                      class="form-control datepicker"
                      placeholder="Selecione a data"
                    >
                  </div>

                  <div class="mt-3 mb-3">
                    <label for="time-service" class="form-label">Horário:</label>
  
                    <input
                      v-model="selectedTime"
                      type="time"
                      class="form-control"
                      placeholder="hh:mm"
                      maxlength="5"
                      @input="maskTime"
                    >
                  </div>

                  <DepositDetails :calendar="getCurrentCalendar" />
                  <div class="mt-3 mb-3">
                    <label for="paymentMethod" class="form-label">Forma de Pagamento (Opcional):</label>
  
                    <select
                      v-model="selectedPaymentMethod"
                      id="paymentMethod"
                      class="form-select"
                    >
                      <option :value="null">Nenhuma</option>
                      <option v-for="method in getPaymentMethods" :key="method.id" :value="method.id">
                        {{ method.name }} <span v-if="method.fee">(Taxa: {{ method.fee }}%)</span>
                      </option>
                    </select>
                  </div>

                </div>

                <div v-if="getCurrentCalendar && getCurrentCalendar.status == 'BLOCKED'">

                  <p class="fs-4">
                    Atendente: {{ getCurrentCalendar.user.name }} <br>
                    Horario inicial: {{ getCurrentCalendar.start_time_service }} <br>
                    Horario final: {{ getCurrentCalendar.end_time_service }}
                  </p>

                  <div v-if="getCurrentCalendar.reason">
                    <label>Motivo de bloqueio (opcional):</label>
                    <textarea
                      :value="getCurrentCalendar.reason.reason"
                      type="text"
                      class="form-control"
                      placeholder="Motivo do bloqueio..."
                      disabled
                    />
                  </div>

                </div>

              </div>

              <div class="modal-footer">
                  <button type="button" class="col-12 col-sm-3 btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                  <button v-if="getCurrentCalendar" type="button" class="col-12 col-sm-4 btn btn-danger" @click="deleteSchedule">{{ textButtonAdvanced() }}</button>
                  <button v-if="getCurrentCalendar && getCurrentCalendar.status != 'BLOCKED'" type="button" class="col-12 col-sm-3 btn btn-primary" :disabled="isLoadingUpdate" @click="updateSchedule">{{ isLoadingUpdate ? 'Atualizando...' : 'Atualizar'}}</button>
              </div>
          </div>
      </div>
  </div>

  <div class="modal fade" id="updateConflictModal" tabindex="-1" aria-hidden="true" style="z-index: 1060;">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Conflito de agendamento</h5>
          <button type="button" class="btn-close" @click="closeConflictModal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Já existe um agendamento para este horário. Deseja atualizar o agendamento mesmo assim?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeConflictModal">Não</button>
          <button ref="button_submit_conflict" type="button" class="btn btn-warning" @click="confirmWithConflict">Sim, atualizar mesmo assim</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import DepositDetails from '../../components/Calendar/DepositDetails.vue';
import ConfirmDeleteScheduleModal from './ConfirmDeleteScheduleModal.vue';
import * as bootstrap from 'bootstrap';
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { nextTick } from "vue";

export default {
  name: "UpdateScheduleModal",
  data () {
      return {
        selectedTime: "",
        selectedDate: "",
        selectedPaymentMethod: null,
        isLoadingDelete: false,
        isLoadingUpdate: false,
        datePickerInstance: null,
        conflictParams: null,
      }
  },
  components: {
    ConfirmDeleteScheduleModal, DepositDetails
  },
  watch: {
    getCurrentCalendar: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.start_time_service) {
          this.selectedTime = newVal.start_time_service;
        }
        if (newVal && newVal.date) {
          this.selectedDate = this.normalizeDate(newVal.date);
          if (this.datePickerInstance && typeof this.datePickerInstance.setDate === "function") {
            this.datePickerInstance.setDate(this.selectedDate, false, "Y-m-d");
          }
        } else {
          this.selectedDate = "";
          if (this.datePickerInstance && typeof this.datePickerInstance.clear === "function") {
            this.datePickerInstance.clear();
          }
        }
        if (newVal && newVal.payment_method_id) {
          this.selectedPaymentMethod = newVal.payment_method_id;
        } else {
          this.selectedPaymentMethod = null;
        }

        nextTick(() => {
          if (newVal && newVal.status !== "BLOCKED") {
            this.initDatePicker();
          } else if (this.datePickerInstance && typeof this.datePickerInstance.destroy === "function") {
            this.datePickerInstance.destroy();
            this.datePickerInstance = null;
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentCalendar",
      "getPaymentMethods",
    ]),

    safeDate() {
      if (!this.selectedDate) return null;
      return new Date(this.selectedDate + 'T00:00:00');
    },

    formattedDate() {
      if (!this.safeDate) return '';

      return this.safeDate.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },

    weekDay() {
      if (!this.safeDate) return '';

      const day = this.safeDate.toLocaleDateString('pt-BR', {
        weekday: 'long'
      });

      return day.charAt(0).toUpperCase() + day.slice(1);
    }
  },
  mounted() {
    this.initDatePicker();
  },
  unmounted() {
    if (this.datePickerInstance && typeof this.datePickerInstance.destroy === "function") {
      this.datePickerInstance.destroy();
    }
    this.datePickerInstance = null;
  },
  methods: {
    ...mapActions([
      "saveSchedule",
      "excludeSchedule"
    ]),

    textButtonAdvanced(){
      if(this.getCurrentCalendar && this.getCurrentCalendar.status == 'BLOCKED'){
        return this.isLoadingDelete ? 'Cancelando bloqueio...' : 'Cancelar bloqueio';
      }
      return this.isLoadingDelete ? 'Cancelando agendamento...' : 'Cancelar agendamento';
    },
    normalizeDate(value) {
      if (!value) return "";
      const parsed = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true);
      if (parsed.isValid()) {
        return parsed.format("YYYY-MM-DD");
      }
      return "";
    },
    initDatePicker() {
      const input = this.$refs.dateServiceInput;
      if (!input) {
        return;
      }

      if (this.datePickerInstance && typeof this.datePickerInstance.destroy === "function") {
        this.datePickerInstance.destroy();
        this.datePickerInstance = null;
      }

      this.datePickerInstance = flatpickr(input, {
        locale: Portuguese,
        altInput: true,
        altFormat: "d/m/Y",
        dateFormat: "Y-m-d",
        defaultDate: this.selectedDate || null,
        onChange: (selectedDates, dateStr) => {
          this.selectedDate = dateStr;
        }
      });
    },

    maskTime(event){
      let value = event.target.value;

      // remove tudo que não for número
      value = value.replace(/\D/g, '');

      // limita a 4 dígitos (HHMM)
      value = value.slice(0, 4);

      // adiciona os dois pontos automaticamente
      if (value.length >= 3) {
        value = value.replace(/(\d{2})(\d+)/, '$1:$2');
      }

      event.target.value = value;
    },
    deleteSchedule(){

      const modalEl = document.getElementById('confirmDeleteScheduleModal');

      if (modalEl) {
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }

    },
    updateSchedule(){

      if(this.selectedTime == "" || this.selectedTime == null || this.selectedDate == "" || this.selectedDate == null){
        return;
      }

      this.isLoadingUpdate = true;

      const params = {
        "calendar_id": this.getCurrentCalendar.id,
        "selected_time": this.selectedTime,
        "date": moment(this.selectedDate).format("YYYY-MM-DD"),
        "payment_method_id": this.selectedPaymentMethod
      }

      this.saveSchedule(params).then((result) => {
        this.isLoadingUpdate = false;

        if (result && !result.success && result.status === 409) {
          this.conflictParams = params;
          this.openConflictModal();
        }
      });
    },

    openConflictModal() {
      const modalEl = document.getElementById('updateConflictModal');
      if (modalEl) {
        modalEl.style.display = 'block';
        setTimeout(() => modalEl.classList.add('show'), 10);
        let backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show conflict-backdrop';
        backdrop.style.zIndex = '1055';
        modalEl.style.zIndex = '1060';
        document.body.appendChild(backdrop);
      }
    },

    closeConflictModal() {
      const modalEl = document.getElementById('updateConflictModal');
      if (modalEl) {
        modalEl.classList.remove('show');
        setTimeout(() => { modalEl.style.display = 'none'; }, 300);
      }
      const backdrop = document.querySelector('.conflict-backdrop');
      if (backdrop) backdrop.remove();
      this.conflictParams = null;
    },

    confirmWithConflict() {
      if (!this.conflictParams) return;

      this.$refs.button_submit_conflict.innerHTML = "Carregando...";
      this.$refs.button_submit_conflict.disabled = true;

      const params = { ...this.conflictParams, confirmConflict: true };

      this.saveSchedule(params).then((result) => {
        this.$refs.button_submit_conflict.innerHTML = "Sim, atualizar mesmo assim";
        this.$refs.button_submit_conflict.disabled = false;

        if (result && result.success) {
          this.closeConflictModal();
        } else {
          alert("Falha ao forçar a atualização conflitante. Ocorreu um erro no servidor.");
        }
      });
    }
  }
};
</script>
